<template>
  <div
    class="card card-custom"
    :class="{
      'card-nested': nested,
      'd-print-none': printable == false,
    }"
  >
    <div class="card-header" :class="{ 'card-header-tabs-line': tabs }" v-if="$attrs.icon || title || $attrs.subtitle || $slots.toolbar">
      <div class="card-title" v-if="$attrs.icon || title || $attrs.subtitle || forceTitle">
        <span v-if="$attrs.icon" class="card-icon">
          <i class="text-primary" :class="$attrs.icon"></i>
        </span>
        <h3 class="card-label">
          {{ title }}
          <small>{{ $attrs.subtitle }}</small>
        </h3>
      </div>
      <div class="card-toolbar">
        <slot name="toolbar"></slot>
      </div>
    </div>
    <div class="card-body" :class="bodyClass">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default() {
        return "";
      },
    },
    tabs: {
      type: Boolean,
      default: false,
    },
    forceTitle: {
      type: Boolean,
      default: false,
    },
    nested: {
      type: Boolean,
      default: false,
    },
    printable: {
      type: Boolean,
      default: false,
    },
    bodyClass: {
      type: String,
      default: "",
    },
  },
};
</script>
